import { defineMessages } from 'react-intl';

export const objectWorkspaceChatHarnessMessages = defineMessages({
  emptyTabAdded: {
    defaultMessage: 'New work tab {number} added and selected',
    id: 'CPOjNc9N2e',
    description: 'Screen-reader announcement after adding an empty object work tab',
  },
  tabSelected: {
    defaultMessage: 'Work tab {title} selected',
    id: 'fpV36MubH7',
    description: 'Screen-reader announcement after selecting an object work tab',
  },
  tabAdded: {
    defaultMessage: 'Work tab {title} added and selected',
    id: 'GZWT/F13q9',
    description: 'Screen-reader announcement after adding a seeded object work tab',
  },
  tabClosed: {
    defaultMessage: 'Work tab {title} closed',
    id: 'hJKAh+S9pF',
    description: 'Screen-reader announcement after closing an inactive object work tab',
  },
  tabClosedAndSelected: {
    defaultMessage: 'Work tab {title} closed. Work tab {nextTitle} selected.',
    id: 'O5wUH5HqOF',
    description:
      'Screen-reader announcement after closing and selecting another work tab',
  },
  submissionStarted: {
    defaultMessage: 'Thinking in work tab {title}',
    id: '6H+uX1yVR0',
    description: 'Screen-reader announcement after submitting from an object work tab',
  },
  submissionFailed: {
    defaultMessage: 'Message failed in work tab {title}. Your draft was restored.',
    id: 'KlEcRYCLgS',
    description: 'Screen-reader announcement after an object work tab create fails',
  },
  heidiTab: {
    defaultMessage: 'Heidi',
    id: '+snRzkRPsW',
    description: 'Permanent root tab in the object workspace',
  },
});
